import React, { useEffect, useRef, useState, useMemo } from 'react';
import { toJS } from 'mobx';
import { ListItem } from './styled';

const teamNameState = {
  HOME: '',
  AWAY: ''
};
const BasketballBroadCastItem = ({ selectedPeriod, period, data, teams }) => {
  const [viewDetail, setViewDetail] = useState(false);
  const [teamNames, setTeamNames] = useState(teamNameState);
  const titleComp = useRef();

  const handleToggleDetail = () => {
    console.log("Asdasdasd");
    const changeView = !viewDetail;
    setViewDetail(!viewDetail);
    if (changeView) {
      const targetScroll = titleComp.current.offsetTop;
      setTimeout(() => {
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }, 10);
    }
  };

  useEffect(() => {
    if (selectedPeriod === parseInt(period)) {
      setViewDetail(true);
    }
  }, []);

  useEffect(() => {
    let teamData = toJS(teams);
    if (teamData !== undefined) {
      setTeamNames({ HOME: teamData.home.name, AWAY: teamData.away.name });
    }
  }, [teams]);

  return (
    <dl className={`item ${viewDetail && 'view'}`}>
      <dt ref={titleComp} onClick={handleToggleDetail}>
        <span className={'tit'}>{period}쿼터</span>
        <button type="button" className="btn_oc">
          열기/닫기
        </button>
      </dt>
      {data.map((value, key) => {
        const prevScore = data[key - 1] ?? { score: { home: 0, away: 0 } };
        if (value.eventType !== 'GOAL') return null;
        return <Item key={key} item={value} prevScore={prevScore} />;
      })}
    </dl>
  );
};

const calculateDiff = (prevHome, prevAway, home, away) => {
  const currentDiff = (home ?? 0) - (away ?? 0);
  const prevDiff = (prevHome ?? 0) - (prevAway ?? 0);

  let homeDisplay = 0;
  let awayDisplay = 0;
  let homeColor = '';
  let awayColor = '';

  if (currentDiff > 0) {
    homeDisplay = currentDiff;
    homeColor = currentDiff > prevDiff ? 'up' : currentDiff < prevDiff ? 'down' : '';
  } else if (currentDiff < 0) {
    awayDisplay = Math.abs(currentDiff);
    awayColor = currentDiff < prevDiff ? 'up' : currentDiff > prevDiff ? 'down' : '';
  }

  return {
    homeDisplay,
    awayDisplay,
    homeColor,
    awayColor,
  };
};

const Item = ({ item, prevScore, key }) => {
  const { homeDisplay, awayDisplay, homeColor, awayColor } = calculateDiff(
      prevScore.score.home,
      prevScore.score.away,
      item.score.home,
      item.score.away
  );

  const styleClass = useMemo(() => {
    return {
      styleHomeScore: item.score.home > prevScore.score.home ? 'up' : '',
      styleAwayScore: item.score.away > prevScore.score.away ? 'up' : '',
    };
  }, [item.score.home, item.score.away, prevScore.score.home, prevScore.score.away]);

  return (
      <dd key={key}>
        <ListItem>
          <div className='score-container home'>
            {homeDisplay > 0 && <span className={`diff ${homeColor}`}>{`+${homeDisplay}`}</span>}
            <span className={styleClass.styleHomeScore}>{item.score.home || 0}</span>
          </div>
          <div className='score-container'>
            <span className='separator'>-</span>
          </div>
          <div className='score-container away'>
            <span className={styleClass.styleAwayScore}>{item.score.away || 0}</span>
            {awayDisplay > 0 && <span className={`diff ${awayColor}`}>{`+${awayDisplay}`}</span>}
          </div>
        </ListItem>
      </dd>
  );
};

export default BasketballBroadCastItem;
